import { useQuery } from "utilities";

const useOrderQuery = (page, shop_id) => {
  const query = shop_id
    ? `/order-list?page=${page.page}&shop_id=${shop_id}`
    : `/order-list?page=${page.page}`;
    const { data, isLoading, isError } = useQuery(query);

  return {
    orders: data || [], // Adjust based on API response
    pagination: data?.meta || {}, // Extract pagination meta
    loading: isLoading,
    error: isError,
  };
};

export default useOrderQuery;